import SpinLogo from './SpinLogo';

export default SpinLogo;
